import React from 'react';

interface Props {
  completed: number;
  height?: number;
  extraBgClass?: string;
  mainBgClass?: string;
}

const CampaignProgressBar: React.FC<Props> = ({
  completed,
  height = 5,
  extraBgClass = 'bg-[#78788029]',
  mainBgClass = 'bg-[#FFD700]',
}) => {
  return (
    <div className={`relative w-full rounded-full ${extraBgClass}`}>
      <div className={`h-[${height}px] flex flex-row w-full rounded-full`}>
        <div
          style={{
            width: `${completed}%`,
          }}
          className={`h-[${height}px] ${mainBgClass} rounded-full`}
        ></div>
        <div
          style={{
            width: `${100 - completed}%`,
          }}
          className={`h-[${height}px] ${extraBgClass} rounded-r-full`}
        ></div>
      </div>
      <div className="absolute bottom-0 left-0 w-full"></div>
    </div>
  );
};

export default CampaignProgressBar;
